import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes } from '@angular/router';
import { JhiPaginationUtil, JhiResolvePagingParams } from 'ng-jhipster';
import { UserRouteAccessService } from 'src/app/core';
import { Observable } from 'rxjs';
import { PackingTypeMySuffix } from 'src/app/shared/model/packing-type-my-suffix.model';
import { PackingTypeMySuffixService } from './packing-type-my-suffix.service';
import { PackingTypeMySuffixComponent } from './packing-type-my-suffix.component';
import { PackingTypeMySuffixDetailComponent } from './packing-type-my-suffix-detail.component';
import { PackingTypeMySuffixUpdateComponent } from './packing-type-my-suffix-update.component';
import { PackingTypeMySuffixDeletePopupComponent } from './packing-type-my-suffix-delete-dialog.component';
import { IPackingTypeMySuffix } from 'src/app/shared/model/packing-type-my-suffix.model';

@Injectable({ providedIn: 'root' })
export class PackingTypeMySuffixResolve implements Resolve<IPackingTypeMySuffix> {
    constructor(private service: PackingTypeMySuffixService) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const id = route.params['id'] ? route.params['id'] : null;
        if (id) {
            if (state.url.includes('/view')) {
                return this.service.view(id).map((packingTypeView: HttpResponse<PackingTypeMySuffix>) => packingTypeView.body);
            }
            return this.service.find(id).map((packingType: HttpResponse<PackingTypeMySuffix>) => packingType.body);
        }
        return Observable.of(new PackingTypeMySuffix());
    }
}

export const packingTypeRoute: Routes = [
    {
        path: 'packing-type',
        component: PackingTypeMySuffixComponent,
        resolve: {
            pagingParams: JhiResolvePagingParams
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'AUDIT_USER',
                'AUDIT_USER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            defaultSort: 'id,asc',
            pageTitle: 'PackingTypes'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'packing-type/:id/view',
        component: PackingTypeMySuffixDetailComponent,
        resolve: {
            packingType: PackingTypeMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'AUDIT_USER',
                'AUDIT_USER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'PackingTypes'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'packing-type/new',
        component: PackingTypeMySuffixUpdateComponent,
        resolve: {
            packingType: PackingTypeMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'PackingTypes'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'packing-type/:id/edit',
        component: PackingTypeMySuffixUpdateComponent,
        resolve: {
            packingType: PackingTypeMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'PackingTypes'
        },
        canActivate: [UserRouteAccessService]
    }
];

export const packingTypePopupRoute: Routes = [
    {
        path: 'packing-type/:id/delete',
        component: PackingTypeMySuffixDeletePopupComponent,
        resolve: {
            packingType: PackingTypeMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'PackingTypes'
        },
        canActivate: [UserRouteAccessService],
        outlet: 'popup'
    }
];
